import { useState, useEffect } from 'react'
import { supabase } from '../supabaseClient'

export function useCustomerFeedbackAIHistory() {
    const [history, setHistory] = useState([])
    const [loading, setLoading] = useState(false)

    const fetchHistory = async () => {
        setLoading(true)
        const { data, error } = await supabase
            .from('customer_feedback_ai_history')
            .select('*')
            .order('generated_at', { ascending: false })
            .limit(50)
        if (!error) setHistory(data ?? [])
        setLoading(false)
    }

    const saveAnalysis = async ({ summary, recommendations, scopeLabel, dateRange, startISO, endISO }) => {
        const { data, error } = await supabase
            .from('customer_feedback_ai_history')
            .insert({
                summary,
                recommendations,
                branch_name: scopeLabel,
                date_range: dateRange,
                start_iso: startISO,
                end_iso: endISO,
            })
            .select()
            .single()
        if (!error && data) setHistory(prev => [data, ...prev])
        return { data, error }
    }

    const deleteAnalysis = async (id) => {
        const { error } = await supabase.from('customer_feedback_ai_history').delete().eq('id', id)
        if (!error) setHistory(prev => prev.filter(h => h.id !== id))
        return { error }
    }

    useEffect(() => { fetchHistory() }, [])

    return { history, loading, saveAnalysis, deleteAnalysis, fetchHistory }
}